import { Category, State } from 'src/app/shared/services/common-api.service';

import { HomeContent } from 'src/app/home/models/home-content.model';
import { ClickAction } from 'src/app/home/models/home.model';
import { ColorConfigurations, FontConfigurations } from '../services/theme/theme.service';
import { BusinessAddress } from './business-address.interface';

export interface Environment {
    client_id: string;
    client_secret: string;
    sales_channel_code: string;
    sellerId: string;
    // for version 1 
    url: string;
    // for version 2
    url_2?: string;
    // for product APIs (without seller path)
    product_url?: string;
    product_url_2?: string;
}
export interface StoreConfiguration {
    /** Flag to enable mobile OTP based login flows */
    mobile_otp_login_enabled?: boolean;
    id: string;
    company: Company;
    name: string;
    logos: [Logo<LogoType.Rectangular>, Logo<LogoType.Square>];
    sales_channel_code: string;
    domain: string;
    display_name: string;
    type: string;
    contact_email?: string;
    contact_mobile_number?: string;
    announcements: Announcement[];
    global_messages?: GlobalMessage[];
    landmark?: string;
    country?: string;
    state?: State;
    gst_number: string;
    business_hours: string;
    city?: string;
    pincode?: string;
    address_line_1?: string;
    address_line_2?: string;
    country_code: string;
    address_legal_name?: string;
    contact_person_name?: string;
    body_end_tags: Script;
    body_start_tags: Script;
    header_tags: Script;
    // sales_channel_page_configurations: PageConfigurations[];
    sales_channel_pages: { category: string, products: string, search: string, product_details: string };
    header_configurations: HeaderConfigurations;
    footer_configurations: FooterConfiguration[];
    body_configurations: BodyConfigurations;
    footer_tags: Script;
    site_map?: any;
    color_configurations: ColorConfigurations;
    badges: ProductBadge[];
    application_configuration: Environment;
    google_ads: GoogleAds;
    show_pincode_check: boolean;
    is_cashpoints_offer_active?: boolean;
    is_deal_active?: boolean;
    show_out_of_stock_products?: boolean;
    font_configurations?: FontConfigurations;
    home_page: {
        published_page_content: string;
        published_page_contents: string,
        page_contents: string;
    };
    is_bidding_active?: boolean;
    show_gpt_widget?: boolean;
    razorpay_configurations?: {
        merchant_id: string;
    };
    is_mobile_first_auth_enabled?: boolean;

}


export interface DynamicPageConfiguration {
    style_configuration: CategoryLayoutStyle,
    data_configuration: CategoryLayoutData
}

export interface CategoryLayoutData {
    categoryLayoutConfig: CategoryLayoutConfig;
    bannerConfiguration: {};
    filterData: FilterData;
    toolBarData: ToolBarData;
    paginationData: PaginationData;
    productCardData: ProductCardData;
}

export interface CategoryLayoutConfig {
    categoryLayoutType: string;
    themeBackgroundColor: string;
    themeFontFamily: string;
}
export interface FilterData {
    mainConfiguration: {},
    styleConfiguration: {
        desktopStyleConfiguration: CategoryFilterDesktopStyleConfiguration;

        mobileStyleConfiguration: CategoryFilterMobileStyleConfiguration;
    },
    advanceConfiguration: {
    }
}


export interface CategoryFilterMobileStyleConfiguration {
    filterCardBorderColor: string;
    filterCategoryNameTextSize: string;
    filterCategoryNameTextColor: string;
    filterCategoryNameTextTransform: string;
    filterCategoryNameTextFontWeight: string;
    filterCardBackground: string;
    filterCardBorderRadiusTopLeft: string;
    filterCardBorderRadiusTopRight: string;
    filterCardBorderRadiusBottomRight: string;
    filterCardBorderRadiusBottomLeft: string;
    filterClearBtnTextSize: string;
    filterClearBtnTextColor: string;
    filterClearBtnTextFontWeight: string;
    filterChipBorderColor: string;
    filterChipBorderRadiusTopLeft: string;
    filterChipBorderRadiusTopRight: string;
    filterChipBorderRadiusBottomRight: string;
    filterChipBorderRadiusBottomLeft: string;
    filterChipTextSize: string;
    filterChipTextColor: string;
    filterChipBackground: string;
    filterChipTextFontWeight: string;
    facetLabelTextSize: string;
    facetLabelTextColor: string;
    facetLabelTextFontWeight: string;
    facetArrowUpBorderColor: string;
    facetArrowDownBorderColor: string;
    facetLabelTextTransform: string;
    facetLabelBackgroundColor: string;
    facetLabelBorderColor: string;
    facetLabelBorderRadiusTopLeft: string;
    facetLabelBorderRadiusTopRight: string;
    facetLabelBorderRadiusBottomRight: string;
    facetLabelBorderRadiusBottomLeft: string;
    filterChipTextTransform: string;
    filterOptionTextTransform: string;
    filterClearBtnTextTransform: string;
    filterOptionTextSize: string;
    filterOptionTextColor: string;
    filterOptionFontWeight: string;
    filterOptionBackground: string;
    checkBoxBackgroundColor: string;
    checkBoxBorderRadiusTopLeft: string;
    checkBoxBorderRadiusTopRight: string;
    checkBoxBorderRadiusBottomRight: string;
    checkBoxBorderRadiusBottomLeft: string;
    filterOptionBackgroundActive: string;
    filterOptionBorderColorActive: string;
    filterCheckBoxBorderColor: string;
    filterCheckMarkIconColorActive: string;
}

export interface CategoryFilterDesktopStyleConfiguration {
    filterCardBorderColor: string;
    filterCategoryNameTextSize: string;
    filterCategoryNameTextColor: string;
    filterCategoryNameTextTransform: string;
    filterCategoryNameTextFontWeight: string;
    filterCardBackground: string;
    filterCardBorderRadiusTopLeft: string;
    filterCardBorderRadiusTopRight: string;
    filterCardBorderRadiusBottomRight: string;
    filterCardBorderRadiusBottomLeft: string;
    filterClearBtnTextSize: string;
    filterClearBtnTextColor: string;
    filterClearBtnTextFontWeight: string;
    filterChipBorderColor: string;
    filterChipBorderRadiusTopLeft: string;
    filterChipBorderRadiusTopRight: string;
    filterChipBorderRadiusBottomRight: string;
    filterChipBorderRadiusBottomLeft: string;
    filterChipTextSize: string;
    filterChipTextColor: string;
    filterChipBackground: string;
    filterChipTextFontWeight: string;
    facetLabelTextSize: string;
    facetLabelTextColor: string;
    facetLabelTextFontWeight: string;
    facetArrowUpBorderColor: string;
    facetArrowDownBorderColor: string;
    facetLabelTextTransform: string;
    facetLabelBackgroundColor: string;
    facetLabelBorderColor: string;
    facetLabelBorderRadiusTopLeft: string;
    facetLabelBorderRadiusTopRight: string;
    facetLabelBorderRadiusBottomRight: string;
    facetLabelBorderRadiusBottomLeft: string;
    filterChipTextTransform: string;
    filterOptionTextTransform: string;
    filterClearBtnTextTransform: string;
    filterOptionTextSize: string;
    filterOptionTextColor: string;
    filterOptionFontWeight: string;
    filterOptionBackground: string;
    checkBoxBackgroundColor: string;
    checkBoxBorderRadiusTopLeft: string;
    checkBoxBorderRadiusTopRight: string;
    checkBoxBorderRadiusBottomRight: string;
    checkBoxBorderRadiusBottomLeft: string;
    filterOptionBackgroundActive: string;
    filterOptionBorderColorActive: string;
    filterCheckBoxBorderColor: string;
    filterCheckMarkIconColorActive: string;
}

export interface ToolBarData {
    mainConfiguration: {},
    styleConfiguration: {
        desktopStyleConfiguration: CategoryToolDesktopStyleConfiguration;

        mobileStyleConfiguration: ToolBarDataMobileStyleConfiguration;
    },
    advanceConfiguration: {

    }
}

export interface CategoryToolDesktopStyleConfiguration {
    mainCardBackground: string,
    mainCardBorderRadiusTopLeft: string,
    mainCardBorderRadiusTopRight: string,
    mainCardBorderRadiusBottomRight: string,
    mainCardBorderRadiusBottomLeft: string,
    mainCardBorderColor: string,
    dropdownButtonBackground: string,
    dropdownButtonBorderRadiusTopLeft: string,
    dropdownButtonBorderRadiusTopRight: string,
    dropdownButtonBorderRadiusBottomRight: string,
    dropdownButtonBorderRadiusBottomLeft: string,
    dropdownButtonBorderColor: string,
    dropdownButtonTextSize: string,
    dropdownButtonTextColor: string,
    sortArrowDownBorderColor: string,
    dropdownButtonTextFontWeight: string,
    dropdownButtonTextTransform: string,
    viewAsTextSize: string,
    viewAsTextColor: string,
    viewAsTextFontWeight: string,
    sortByTextSize: string,
    sortByTextColor: string,
    sortByTextFontWeight: string,
    sortByTextTransform: string,
    viewAsTextTransform: string,
    gridTileColor: string,
    activeGridTileColor: string
}

export interface ToolBarDataMobileStyleConfiguration {
    mainCardBackground: string,
    mainCardBorderRadiusTopLeft: string,
    mainCardBorderRadiusTopRight: string,
    mainCardBorderRadiusBottomRight: string,
    mainCardBorderRadiusBottomLeft: string,
    mainCardBorderColor: string,
    dropdownButtonBackground: string,
    sortArrowDownBorderColor: string,
    dropdownButtonBorderRadiusTopLeft: string,
    dropdownButtonBorderRadiusTopRight: string,
    dropdownButtonBorderRadiusBottomRight: string,
    dropdownButtonBorderRadiusBottomLeft: string,
    dropdownButtonBorderColor: string,
    dropdownButtonTextSize: string,
    dropdownButtonTextColor: string,
    dropdownButtonTextFontWeight: string,
    dropdownButtonTextTransform: string,
    viewAsTextSize: string,
    viewAsTextColor: string,
    viewAsTextFontWeight: string,
    sortByTextSize: string,
    sortByTextColor: string,
    sortByTextFontWeight: string,
    sortByTextTransform: string,
    viewAsTextTransform: string,
    gridTileColor: string,
    activeGridTileColor: string
}


export interface PaginationData {
    mainConfiguration: {},
    styleConfiguration: {
        desktopStyleConfiguration: PaginationDataDesktopStyleConfiguration;

        mobileStyleConfiguration: PaginationDataMobileStyleConfiguration;
    },
    advanceConfiguration: {

    }
}

export interface PaginationDataDesktopStyleConfiguration {
    paginationBtnTextSize: string,
    paginationBtnTextColor: string,
    paginationBtnBackground: string,
    paginationBtnFontWeight: string,
    paginationBtnTextTransform: string,
    paginationBtnBorderColor: string,
    paginationBtnBorderRadiusTopLeft: string,
    paginationBtnBorderRadiusTopRight: string,
    paginationBtnBorderRadiusBottomRight: string,
    paginationBtnBorderRadiusBottomLeft: string,
    pageCountBtnTextSize: string,
    pageCountBtnTextColor: string,
    pageCountBtnBackground: string,
    pageCountBtnFontWeight: string,
    pageCountBtnTextTransform: string,
    pageCountBtnBorderColor: string,
    pageCountBorderRadiusTopLeft: string,
    pageCountBorderRadiusTopRight: string,
    pageCountBorderRadiusBottomRight: string,
    pageCountBorderRadiusBottomLeft: string,
}

export interface PaginationDataMobileStyleConfiguration {
    paginationBtnTextSize: string,
    paginationBtnTextColor: string,
    paginationBtnBackground: string,
    paginationBtnFontWeight: string,
    paginationBtnTextTransform: string,
    paginationBtnBorderColor: string,
    paginationBtnBorderRadiusTopLeft: string,
    paginationBtnBorderRadiusTopRight: string,
    paginationBtnBorderRadiusBottomRight: string,
    paginationBtnBorderRadiusBottomLeft: string,
    pageCountBtnTextSize: string,
    pageCountBtnTextColor: string,
    pageCountBtnBackground: string,
    pageCountBtnFontWeight: string,
    pageCountBtnTextTransform: string,
    pageCountBtnBorderColor: string,
    pageCountBorderRadiusTopLeft: string,
    pageCountBorderRadiusTopRight: string,
    pageCountBorderRadiusBottomRight: string,
    pageCountBorderRadiusBottomLeft: string,
}

export interface ProductCardData {
    mainConfiguration: {},
    styleConfiguration: {
        desktopStyleConfiguration: ProductCardDataDesktopStyleConfiguration;

        mobileStyleConfiguration: ProductCardDataMobileStyleConfiguration;
    },
    advanceConfiguration: {
        mobile: {
            isBrandNameVisible: boolean,
            isAddToCartVisible: boolean,
            isProductVariantVisible: boolean,
            isPreviewDetailsVisible: boolean,
            isProductNameVisible?: boolean,
            isProductPriceVisible?: boolean,
            isProductImageVisible?: boolean,
            isPercentageDiscountVisible?: boolean,
            isDealCountdownVisible?: boolean
        },
        desktop: {
            isBrandNameVisible: boolean,
            isAddToCartVisible: boolean,
            isProductVariantVisible: boolean,
            isPreviewDetailsVisible: boolean,
            isProductNameVisible?: boolean,
            isProductPriceVisible?: boolean,
            isProductImageVisible?: boolean,
            isPercentageDiscountVisible?: boolean,
            isDealCountdownVisible?: boolean
        },
        isTagVisible: boolean,
        mobileGridLayout: boolean,
        isDescriptionVisible: boolean
    }
}
export enum MOBILE_GRID_LAYOUT {
    GRID_LAYOUT1 = "gridLayout1",
    GRID_LAYOUT2 = "gridLayout2",
}

export interface ProductCardDataDesktopStyleConfiguration {
    productCardBackground: string,
    productCardBorderColor: string,
    productCardBorderTopLeftRadius: string,
    productCardBorderTopRightRadius: string,
    productCardBorderBottomRightRadius: string,
    productCardBorderBottomLeftRadius: string,
    productNameTextSize: string,
    productNameTextColor: string,
    productNameFontWeight: string,
    productNameTextTransform: string,
    brandNameTextSize: string,
    brandNameTextColor: string,
    brandNameFontWeight: string,
    brandNameTextTransform: string,
    discountedPriceTextSize: string,
    discountedPriceTextColor: string,
    discountedPriceFontWeight: string,
    actualPriceTextSize: string,
    percentageDiscountTextColor: string,
    percentageDiscountTextSize: string,
    percentageDiscountFontWeight: string,
    actualPriceTextColor: string,
    actualPriceFontWeight: string,
    productCardTagBackground: string,
    productCardTagBorderColor: string,
    productCardTagTextSize: string,
    productCardTagTextColor: string,
    productCardTagFontWeight: string,
    productCardTagTextTransform: string,
    productCardTagBorderTopLeftRadius: string,
    productCardTagBorderTopRightRadius: string,
    productCardTagBorderBottomRightRadius: string,
    productCardTagBorderBottomLeftRadius: string,
    productCardDescriptionTextSize: string,
    productCardDescriptionTextColor: string,
    productCardDescriptionFontWeight: string,
    productCardDescriptionLineHeight: string
}
export interface ProductCardDataMobileStyleConfiguration {
    productCardBackground: string,
    productCardBorderColor: string,
    productCardBorderTopLeftRadius: string,
    productCardBorderTopRightRadius: string,
    productCardBorderBottomRightRadius: string,
    productCardBorderBottomLeftRadius: string,
    productNameTextSize: string,
    productNameTextColor: string,
    percentageDiscountTextColor: string,
    percentageDiscountTextSize: string,
    percentageDiscountFontWeight: string,
    productNameFontWeight: string,
    productNameTextTransform: string,
    brandNameTextSize: string,
    brandNameTextColor: string,
    brandNameFontWeight: string,
    brandNameTextTransform: string,
    discountedPriceTextSize: string,
    discountedPriceTextColor: string,
    discountedPriceFontWeight: string,
    actualPriceTextSize: string,
    actualPriceTextColor: string,
    actualPriceFontWeight: string,
    productCardTagBackground: string,
    productCardTagTextSize: string,
    productCardTagBorderColor: string,
    productCardTagTextColor: string,
    productCardTagFontWeight: string,
    productCardTagTextTransform: string,
    productCardTagBorderTopLeftRadius: string,
    productCardTagBorderTopRightRadius: string,
    productCardTagBorderBottomRightRadius: string,
    productCardTagBorderBottomLeftRadius: string,
    productCardDescriptionTextSize: string,
    productCardDescriptionTextColor: string,
    productCardDescriptionFontWeight: string,
    productCardDescriptionLineHeight: string
}

export interface CategoryLayoutStyle {
    category_layout_style: string;
    tool_bar_style: string;
    filter_template_style: string;
    product_layout_style: string;
}

export interface GoogleAds {
    propertyId: string;
    [key: string]: any;
}

export interface ProductBadge {
    icon: string;
    title: string;
    description: string;
}

export interface GlobalMessage {
    page?: GlobalMessagePage;
    type: MessageType;
    message: string;
    comment?: string;
}

export enum MessageType {
    Warning = 'warning',
    Information = 'information'
}


export enum GlobalMessagePage {
    ProductDetailPage = 'product_details',
    CartPage = 'cart_page',
    OrderSuccessfulPage = 'order_successful_page',
    OrderHistoryPage = 'order_history_page',
    PaymentMethodTop = 'payment_method_top',
    PaymentMethodBottom = 'payment_method_below_continue',
    MyAccountPage = 'my_account',
    CheckoutPage = 'my_account',
}
export interface Variables {
    company_name: string;
    [key: string]: any;
}

export enum LogoType {
    Rectangular = 'rectangle',
    Square = 'square'
}
export interface Logo<T = LogoType> {
    format: T;
    url: string;
}
export interface Company {
    id: string;
    name: string;
    account_id: string;
}

export interface SupportContactDetails {
    title: string;
    is_visible: boolean;
    contact_email: string;
    contact_number: string;
    contact_person_name: string;
}

export interface HeaderConfigurations {
    title: string;
    favicon: string;
    meta_title: string;
    search_keywords: any[];
    meta_description: string;
    is_about_us_in_menu: boolean;
    support_contact_details: SupportContactDetails;
    is_warranty_registration_required: boolean;
    desktopStickyHeader?: boolean;
    mobileStickyHeader?: boolean;
}

export interface SubSection {
    title: string;
    position: number;
    is_visible: boolean;
    click_action: ClickAction;
    type: string;
    description: string;
    contact_email: string;
    contact_number: string;
    contact_person_name: string;
    text: string;
    url: string;
    icon: string;
}

export interface FooterConfiguration {
    title: string;
    position: number;
    identifier: string;
    is_visible: boolean;
    sub_sections: SubSection[];
}

export interface Image {
    tag: string;
    url: string;
}

export interface BodyConfigurations {
    categories: Category[];
    home_content_sections: HomeContent[]
}

export interface ProductCollection {
    id: string;
}

export interface Script {
    script: string;
}

export interface ProductComplaint {
    addressConfig: {
        is_visible: boolean;
        address: BusinessAddress;
    };
    contactNumberConfig: {
        is_visible: boolean;
        number: string;
    };
    contactEmailConfig: {
        is_visible: boolean;
        email: string;
    };
    productComplaintMessage: {
        is_visible: boolean;
        message: string;
    };
}

export interface DealerEnquiry {
    addressConfig: {
        is_visible: boolean;
        address: BusinessAddress;
    };
    contactNumberConfig: {
        is_visible: boolean;
        number: string;
    };
    contactEmailConfig: {
        is_visible: boolean;
        email: string;
    };
    companyNameConfig: {
        is_visible: boolean;
        name: string;
    };
}

export interface BulkDiscountEnquiry {
    addressConfig: {
        is_visible: boolean;
        address: BusinessAddress;
    };
    contactNumberConfig: {
        is_visible: boolean;
        number: string;
    };
    contactEmailConfig: {
        is_visible: boolean;
        email: string;
    };
    bulkDiscountMessage: {
        is_visible: boolean;
        message: string;
    };
}

export interface OrderEnquiry {

    contactNumberConfig: {
        is_visible: boolean;
        number: string;
    };
    contactEmailConfig: {
        is_visible: boolean;
        email: string;
    };
    orderEnquiryMessage: {
        is_visible: boolean;
        message: string;
    };

}

export interface Announcement {
    message: string;
    comment: string;
    page: AnnouncementBarPage[];
    background_color: string;
    text_color: string;
}

export enum AnnouncementBarPage {
    HomePage = 'HomePage',
    ProductListingPage = 'ProductListingPage',
    ProductDetailPage = 'ProductDetailPage',
    CartPage = 'CartPage'
}

export interface StoreContactDetails {
    contact_mobile_number: string;
    contact_email: string;
}
